import request from '@/utils/request.js';

/**
 * 获取网格单元详情
 * 返回单元格信息、航点列表
 * @param {String} [id] 查询参数
 */
export const getGridUnitDetail = (id) =>
    request({
        url: '/data/gridInfo/getGridUnitDetail',
        method: 'get',
        params: { id },
    });

/**
 * 【城管业务】查询网格航点的历史图片列表
 * @param {String} [id] 查询参数
 */
export const getHistoryFlightImages = (params) =>
    request({
        url: '/data/gridInfo/getHistoryFlightImages',
        method: 'get',
        params,
    });

/**
 * 【城管业务】查询网格单元最新飞行图片列表
 * @param {String} [id] 查询参数
 */
export const getLatestFlightImages = (id) =>
    request({
        url: '/data/gridInfo/getLatestFlightImages',
        method: 'get',
        params: { id },
    });

/**
 * 【城管业务】查询网格单元疑似事件列表
 * @param {String} [id] 查询参数
 */
export const getSuspiciousEvents = (params) =>
    request({
        url: '/data/gridInfo/getSuspiciousEvents',
        method: 'get',
        params,
    });
/**
 * 【城管业务】查询网格单元任务列表
 * @param {String} [id] 查询参数
 */
export const getSuspiciousEventDetail = (params) =>
    request({
        url: '/data/gridInfo/getSuspiciousEventDetail',
        method: 'get',
        params,
    });
